export default __webpack_public_path__ + "static/media/ken-classroom.290c3029.jpg";